<template>

  <v-row>
    <v-col cols="12">
      <v-card flat class="kim-card secondary-card">

        <v-card-text>

          <v-row>
            <v-col cols="12">
              <v-list two-line subheader class="transparent">

                <v-subheader >Resumen</v-subheader>

                <v-list-item

                >
                  <v-list-item-avatar>
                    <v-avatar color="grey ">
                      <v-icon color="white">fa-user-tie</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{name}}</v-list-item-title>
                    <v-list-item-subtitle>Especialista</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <template v-if="!individualProvider">
                      <v-btn class="mr-3" fab small dark color="secondary" @click="$emit('click:edit:specialist')"><v-icon>fa-pen</v-icon></v-btn>
                    </template>
                  </v-list-item-action>

                </v-list-item>


                <v-list-item

                >
                  <v-list-item-avatar>
                    <v-avatar color="grey ">
                      <v-icon color="white">fa-calendar-alt</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{date}}</v-list-item-title>
                    <v-list-item-subtitle>Fecha y Hora</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn class="mr-3" fab small dark color="secondary" @click="$emit('click:edit:date')"><v-icon>fa-pen</v-icon></v-btn>
                  </v-list-item-action>
                </v-list-item>


                <v-subheader v-if="internal || (!internal && vcAllowed)">Configuración</v-subheader>


                <v-flex xs12 class="my-1 px-3" v-if="useLabelsOnAppointments">
                  <label-picker
                      :disable-creation="!canCreateLabels"
                      :value="defaultLabels"
                      @change="labels = $event"
                      type="event"
                      outlined v-if="internal" />
                </v-flex>


                <v-list-item
                    v-if="internal"
                >
                  <v-list-item-avatar>
                    <v-avatar color="grey ">
                      <v-icon size="20" color="white">fa-coffee</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Cita sin costo</v-list-item-title>
                    <v-list-item-subtitle>Ej. Para controles, ofertas, etc.</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-switch
                        color="secondary"
                        v-model="free" />
                  </v-list-item-action>

                </v-list-item>


                <v-list-item

                    v-if="vcAllowed"
                >
                  <v-list-item-avatar>
                    <v-avatar color="grey ">
                      <v-icon size="20" color="white">fa-video</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Cita por video</v-list-item-title>
                    <v-list-item-subtitle>Se enviará un link de videollamada</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-switch
                        color="secondary"
                        v-model="vc" />
                  </v-list-item-action>

                </v-list-item>

              </v-list>
            </v-col>
          </v-row>

        </v-card-text>

      </v-card>
    </v-col>
  </v-row>

</template>

<script>
    import LabelPicker from "@/components/common/LabelPicker";
    import ProviderSettingsMixin from "@/mixins/ProviderSettingsMixin";
    export default{
      components: {LabelPicker},
      mixins: [ProviderSettingsMixin],
      props: {
        internal: {
          type: Boolean,
          default: false
        },
        individualProvider: {
          type: Boolean,
          default: false
        },
        event: {
          type: Object,
          required: true
        },
        schedule: {
          type: Object,
          required: true
        },
        vcAllowed: {
          type: Boolean,
          default: true
        },
        defaultFree: {
          type: Boolean,
          default: false
        },
        defaultVc: {
          type: Boolean,
          default: false
        },
        defaultLabels: {
          type: Array,
          default: () => []
        }
      },
        data(){
            return {
              free: false,
              vc: false,
              labels: []
            }
        },
        mounted(){
          const vm = this
          vm.setDefaults()
        },
        methods: {
          setDefaults(){
            const vm = this
            vm.free = vm.defaultFree
            vm.vc = vm.defaultVc
            vm.labels = vm.defaultLabels
          }
        },
        computed:{
            name(){
                var vm = this
                return vm.schedule.specialist && `${vm.schedule.specialist.first_name} ${vm.schedule.specialist.last_name}` ||
                        `${vm.schedule.service_item.service.name} | ${vm.schedule.service_item.description}`
            },
            date(){
                var vm = this
                return `${vm.$moment(vm.event.date).format('ddd DD MMM').toUpperCase()} a las ${vm.event.time}`
            }
        },
        watch:{
            free(val){
                this.$emit('change:free', val)
            },
            vc(val){
                this.$emit('change:vc', val)
            },
            labels(val){
                this.$emit('change:labels', val)
            }
        }
    }
</script>
